import { ReactNode } from 'react';

import { Endpoint } from '../Endpoint';
import { useWsEdnpointsStyles } from './useWsEndpointsStyles';

export interface WSEndpointsProps {
  title: ReactNode;
  wss: string[];
}

export const WSEndpoints = ({ title, wss }: WSEndpointsProps) => {
  const { classes } = useWsEdnpointsStyles();

  return wss.length > 0 ? (
    <div className={classes.root}>
      {title}
      {wss.map(url => (
        <Endpoint key={url} url={url} />
      ))}
    </div>
  ) : null;
};
